'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _buttons = require('@sitebase/ui-kit/es/buttons');

var _constants = require('../../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Consent = function Consent(_ref) {
  var link = _ref.link,
      showConsent = _ref.showConsent,
      t = _ref.t,
      onConsentClick = _ref.onConsentClick;
  return showConsent && _react2.default.createElement(
    'div',
    { className: 'qd__consent' },
    t(_constants.TRANSLATION_CONTEXT)('CONSENT', {
      link: _react2.default.createElement(
        _buttons.Anchor,
        {
          className: 'qd__consent--link',
          target: '_blank',
          rel: 'noopener noreferrer',
          href: link,
          onClick: onConsentClick,
          key: 'consent-link',
          outfit: 'white small'
        },
        t(_constants.TRANSLATION_CONTEXT)('CONSENT_LINK')
      )
    })
  );
};
exports.default = Consent;